export const contactNote = 'Send a message using the form below, or email';
